import './Footer.css';
import aiFreeCommitmentBlackNB from '../assets/images/aiFreeCommitment/aiFreeCommitmentBlackNB.png'
import React from "react";
import { Link } from 'react-router-dom';

function Footer() {

    return (
        <div class="footer">
            <div className="footerLine"></div>
            <footer className="">
                <nav>
                    <h1 className="footerHeader"> SITE NAVIGATOR</h1>
                    <ul className="navItemList">
                        <li><Link className="navItem" to="/">Home</Link></li>
                        <li><Link className="navItem" to="/mission">Mission</Link></li>
                        <li><Link className="navItem" to="/portfolio">Portfolio</Link></li>
                        <li><Link className="navItem" to="/ai-free-commitment">AI Free Commitment</Link></li>
                        <li><Link className="navItem" to="/terms">Terms and Privacy</Link></li>
                    </ul>
                </nav>
                <div className="footerRow">
                    <p href="/" className="footerText"> © 2025 Cerise Technology LLC</p>
                    <a href="/ai-free-commitment" className="aiFreeCommitmentImageHref" >
                        <img src={aiFreeCommitmentBlackNB} alt="certified generative AI free - click to learn more about our commitment" className="aiFreeCommitmentImage" />
                    </a>
                </div>
            </footer>
        </div>
    )
}

export default Footer;